import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const TrashIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('TrashIcon', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path d="M20,6h-4V5c0-1.65-1.35-3-3-3h-2C9.35,2,8,3.35,8,5v1H4C3.45,6,3,6.45,3,7s0.45,1,1,1h1v11c0,1.65,1.35,3,3,3h8 c1.65,0,3-1.35,3-3V8h1c0.55,0,1-0.45,1-1S20.55,6,20,6z M10,5c0-0.55,0.45-1,1-1h2c0.55,0,1,0.45,1,1v1h-4V5z M17,19 c0,0.55-0.45,1-1,1H8c-0.55,0-1-0.45-1-1V8h10V19z" />
    <path d="M10,17c-0.55,0-1-0.45-1-1v-4c0-0.55,0.45-1,1-1s1,0.45,1,1v4C11,16.55,10.55,17,10,17z" />
    <path d="M14,17c-0.55,0-1-0.45-1-1v-4c0-0.55,0.45-1,1-1s1,0.45,1,1v4C15,16.55,14.55,17,14,17z" />
  </svg>
);

export default TrashIcon;